function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Animate from '../Animate';
import Box from '../Box';
import Button from '../Button';
import Grid from '../Grid';
function CroppedImageInputActions(_ref) {
  var handleCancel = _ref.handleCancel,
    cancelling = _ref.cancelling,
    cancelButtonProps = _ref.cancelButtonProps,
    handleImageSave = _ref.handleImageSave,
    saving = _ref.saving,
    saveButtonProps = _ref.saveButtonProps,
    disabled = _ref.disabled;
  var isNotMobile = useMediaQuery(function (theme) {
    return theme.breakpoints.up('md');
  });
  return /*#__PURE__*/React.createElement(Animate, {
    key: "edit-controls"
  }, /*#__PURE__*/React.createElement(Box, {
    paddingTop: "1.25rem"
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    justifyContent: "flex-end",
    direction: isNotMobile ? 'row' : 'column-reverse',
    spacing: 5
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Button, _extends({
    loading: true,
    color: "primaryAlt",
    variant: "outlined",
    size: "large",
    onClick: handleCancel,
    pending: cancelling,
    disabled: disabled,
    fullWidth: !isNotMobile
  }, cancelButtonProps), cancelButtonProps.text || 'Cancel')), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Button, _extends({
    loading: true,
    color: "primary",
    size: "large",
    onClick: handleImageSave,
    pending: saving,
    disabled: disabled,
    fullWidth: !isNotMobile
  }, saveButtonProps), saveButtonProps.text || 'Save')))));
}
CroppedImageInputActions.propTypes = process.env.NODE_ENV !== "production" ? {
  handleCancel: PropTypes.func.isRequired,
  cancelling: PropTypes.bool,
  cancelButtonProps: PropTypes.object.isRequired,
  handleImageSave: PropTypes.func.isRequired,
  saving: PropTypes.bool,
  saveButtonProps: PropTypes.object.isRequired,
  disabled: PropTypes.bool
} : {};
CroppedImageInputActions.defaultProps = {
  cancelling: false,
  saving: false,
  disabled: false
};
export default CroppedImageInputActions;